import * as React from 'react';
import ActiveDatabaseName from '../Features/Routing/ActiveDatabaseName';

export interface IWithActiveDatabaseName {
  activeDatabaseName: string;
}

export const withActiveDatabaseName =
  <P extends IWithActiveDatabaseName>(
    Component: React.ComponentType<
      React.PropsWithChildren<{ activeDatabaseName: string }>
    >
  ): React.ComponentType<
    React.PropsWithChildren<Omit<P, keyof IWithActiveDatabaseName>>
  > =>
  props =>
    (
      <ActiveDatabaseName>
        {(activeDatabaseName: string | null) => (
          <Component
            {...props}
            activeDatabaseName={activeDatabaseName ?? ''}
          />
        )}
      </ActiveDatabaseName>
    );
export default withActiveDatabaseName;
